import { Box, ButtonBase, Collapse, Typography } from "@mui/material";
import { CollapseChevron } from "components/CollapseChevron";
import { ReactNode, useId, useState } from "react";

export function DrawerDisclosure({ title, children }: { title: string; children: ReactNode }) {
  const id = useId();
  const [open, setOpen] = useState(false);
  return (
    <Box>
      <ButtonBase
        id={`${id}-header`}
        aria-expanded={open}
        aria-controls={`${id}-content`}
        onClick={() => setOpen((value) => !value)}
        sx={{
          width: "100%",
          justifyContent: "flex-start",
          gap: 0.75,
          py: 1.25,
          borderRadius: 0.5,
          textAlign: "left",
          "&:hover": { bgcolor: "action.hover" },
          "&.Mui-focusVisible": { outline: "2px solid", outlineColor: "primary.main" },
        }}
      >
        <CollapseChevron collapsed={!open} />
        <Typography variant="body2" fontWeight={500}>
          {title}
        </Typography>
      </ButtonBase>
      <Collapse in={open}>
        <Box id={`${id}-content`} role="region" aria-labelledby={`${id}-header`} sx={{ pb: 1.5 }}>
          {children}
        </Box>
      </Collapse>
    </Box>
  );
}
